import React from "react";
import R14, { View, Text, StyleSheet, Platform, ControlsView } from "../core";
import { commonStyles } from "../assets/css/commonStyle";
import { commonFontStyles } from "../assets/css/commonFontStyles";
import { commonMetricsStyle } from "../assets/css/commonMetricsStyle";
import { PAGE_PATH, MSG_TYPE } from "../constant/app.data.constant";
import { customCommonStyles } from "../assets/css/customCommonStyle";
import Touchable from "./TouchableComponent";
export default R14.connect(
  class BottomPaySection extends React.Component {
    async paymentNavigation(path, to) {
      this.props.app.nav.to(path, { paytype: to });
    }

    render() {
      const { isDisabled, activePage, extraOpt, billerDetails, billDetails, customBtnStyles, customPaySectionContainer, customActiveBtn, customActiveBtnText, customInActiveBtn, customInActiveBtnText } = this.props;
      let isPayDisable = [MSG_TYPE.PAY_ALL, MSG_TYPE.PAY_PART].includes(extraOpt) || billDetails.billStatus === "In Process";
      let isPartialPayment = (MSG_TYPE.PAY_PART === extraOpt && billDetails.amountPaid < billDetails.billAmount);
      return (
        <ControlsView
          type="buttons"
          style={[styles.bottomControlsView]}
          children={[
            <View key="controlViewBottom" style={[styles.bottomPaySection, commonStyles.flex1, commonStyles.justifyContentSpaceBetween, commonStyles.flexDirectionRow, customPaySectionContainer]}>
              {!!billDetails.allowedRtpResponseTypes && billDetails.allowedRtpResponseTypes.includes(MSG_TYPE.DECLINE) ?
                <View
                  style={[
                    customCommonStyles.payButtons,
                    commonStyles.flex1,
                    styles.bottomPayButtons,
                    customBtnStyles
                  ]}
                >
                <Touchable onPress={() => this.paymentNavigation("declinedRoute", PAGE_PATH.DECLINED)} disabled={!!(isDisabled || isPayDisable)}>
                  <View style={[
                    commonStyles.flex1,
                    commonStyles.justifyContentCenter,
                    commonStyles.alignItemsCenter,
                    commonStyles.textAlignCenter,
                    styles.declineButton,
                    (activePage === PAGE_PATH.DECLINED ? styles.activeBtn : null),
                    activePage === PAGE_PATH.DECLINED ? customActiveBtn : customInActiveBtn,
                    !(isDisabled || isPayDisable) ? null : styles.disable
                  ]}>
                    <Text
                      style={[
                        commonFontStyles.workSans,
                        commonMetricsStyle.exSmallHeading,
                        commonStyles.fontWeight500,
                        commonStyles.transperentBtnColor,
                        activePage === PAGE_PATH.DECLINED ? styles.active : null,
                        activePage === PAGE_PATH.DECLINED ? customActiveBtnText : customInActiveBtnText,
                        !(isDisabled || isPayDisable) ? null : styles.disableText,
                        commonStyles.transformUpperCase
                      ]}>
                      Decline
                    </Text>
                  </View>
                  </Touchable>
                  </View>
                : null}
              {!!billDetails.allowedRtpResponseTypes && billDetails.allowedRtpResponseTypes.includes(MSG_TYPE.REQ_PAY_EXT) ?
                <View
                  style={[
                    customCommonStyles.payButtons,
                    commonStyles.flex1,
                    styles.bottomPayButtons,
                    customBtnStyles
                  ]}
                >
                <Touchable onPress={() => this.paymentNavigation("extensionRoute", PAGE_PATH.EXTENSION)} disabled={!!(isDisabled || isPayDisable)}>
                  <View style={[
                    commonStyles.flex1,
                    commonStyles.justifyContentCenter,
                    commonStyles.alignItemsCenter,
                    commonStyles.textAlignCenter,
                    styles.blueButton,
                    commonStyles.secondaryBtn,
                    (activePage === PAGE_PATH.EXTENSION ? styles.activeBtn : null),
                    activePage === PAGE_PATH.EXTENSION ? customActiveBtn : customInActiveBtn,
                    !(isDisabled || isPayDisable) ? null : styles.disable
                  ]}>
                    <Text
                      style={[
                        commonFontStyles.workSans,
                        commonMetricsStyle.exSmallHeading,
                        commonStyles.fontWeight500,
                        commonStyles.whiteColor,
                        activePage === PAGE_PATH.EXTENSION ? styles.active : null,
                        activePage === PAGE_PATH.EXTENSION ? customActiveBtnText : customInActiveBtnText,
                        !(isDisabled || isPayDisable) ? null : styles.disableText,
                        commonStyles.transformUpperCase
                      ]}>
                      Extension
                    </Text>
                  </View>
                  </Touchable>
                  </View>
              : null}
              {!!billDetails.allowedRtpResponseTypes && billDetails.allowedRtpResponseTypes.includes(MSG_TYPE.PAY_PART) ?
                <View
                  style={[
                    customCommonStyles.payButtons,
                    commonStyles.flex1,
                    styles.bottomPayButtons,
                    customBtnStyles
                  ]}
                >
                <Touchable onPress={() => this.paymentNavigation("payPartialRoute", PAGE_PATH.PAYPART)} disabled={!(!(isDisabled || isPayDisable) || isPartialPayment)}>
                  <View style={[
                    commonStyles.flex1,
                    commonStyles.justifyContentCenter,
                    commonStyles.alignItemsCenter,
                    commonStyles.textAlignCenter,
                    styles.blueButton,
                    commonStyles.secondaryBtn,
                    (activePage === PAGE_PATH.PAYPART ? styles.activeBtn : null),
                    activePage === PAGE_PATH.PAYPART ? customActiveBtn : customInActiveBtn,
                    (!(isDisabled || isPayDisable) || isPartialPayment) ? null : styles.disable
                  ]}>
                    <Text
                      style={[
                        commonFontStyles.workSans,
                        commonMetricsStyle.exSmallHeading,
                        commonStyles.fontWeight500,
                        commonStyles.whiteColor,
                        activePage === PAGE_PATH.PAYPART ? styles.active : null,
                        activePage === PAGE_PATH.PAYPART ? customActiveBtnText : customInActiveBtnText,
                        Platform.OS === 'web' && styles.fullWidth,
                        commonStyles.textAlignCenter,
                        (!(isDisabled || isPayDisable) || isPartialPayment) ? null : styles.disableText,
                        commonStyles.transformUpperCase
                      ]}>
                      Pay Part
                    </Text>
                  </View>
                  </Touchable>
                  </View>
                : null}
              {(!!billerDetails && !!billerDetails.isPaymentsFull) || (!!billDetails.allowedRtpResponseTypes && billDetails.allowedRtpResponseTypes.includes(MSG_TYPE.PAY_ALL)) ?
                <View
                  style={[
                    customCommonStyles.payButtons,
                    commonStyles.flex1,
                    styles.bottomPayButtons,
                    commonStyles.marRT0,
                    customBtnStyles
                  ]}
                >
                <Touchable onPress={() => this.paymentNavigation("payTypeRoute", PAGE_PATH.PAYFULL)} disabled={!!(isDisabled || isPayDisable)}>
                  <View style={[
                    commonStyles.flex1,
                    commonStyles.justifyContentCenter,
                    commonStyles.alignItemsCenter,
                    commonStyles.textAlignCenter,
                    styles.blueButton,
                    (activePage === PAGE_PATH.PAYFULL ? styles.activeBtn : null),
                    activePage === PAGE_PATH.PAYFULL ? customActiveBtn : customInActiveBtn,
                    !(isDisabled || isPayDisable) ? null : styles.disable
                  ]}>
                    <Text
                      style={[
                        commonFontStyles.workSans,
                        commonMetricsStyle.exSmallHeading,
                        commonStyles.fontWeight500,
                        commonStyles.whiteColor,
                        activePage === PAGE_PATH.PAYFULL ? styles.active : null,
                        activePage === PAGE_PATH.PAYFULL ? customActiveBtnText : customInActiveBtnText,
                        Platform.OS === 'web' && styles.fullWidth,
                        commonStyles.textAlignCenter,
                        !(isDisabled || isPayDisable) ? null : styles.disableText,
                        commonStyles.transformUpperCase
                      ]}>
                      Pay All
                    </Text>
                  </View>
                  </Touchable>
                  </View>
                : null}
            </View>]}
            />
      );
    }
  }
);

const styles = StyleSheet.create({
  bottomPaySection: {
    // borderTop: "1px solid #C8C8C8",
    paddingTop: 10,
    paddingRight: 0,
    paddingBottom: 10,
    paddingLeft: 0,
    width: "100%",
  },
  fullWidth: {
    width: "100%",
    // screen: ({ width }) => {
    //   if (width <= 420)
    //   return {
    //         width: "100%",
    //     };
    // }
  },
  payOptImages: {
    display: "block",
    width: 24,
    height: 24,
    backgroundSize: "contain",
    marginTop: 0,
    marginRight: "auto",
    marginBottom: 0,
    marginLeft: "auto",
  },
  active: {
    color: "#888888",
  },
  activeBtn: {
    opacity: 1,
    pointerEvents: "none",
    backgroundColor: "#f4f4f4",
    cursor:"auto",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    borderColor: "#f4f4f4"
  },
  disable: {
    opacity: 1,
    backgroundColor: "#f4f4f4",
    borderColor: "#f4f4f4",
    borderWidth: 1,
    borderStyle: "solid",
    // cursor: "auto",
  },
  disableText: {
    color: "#888888"
  },
  bottomControlsView: {
    // display: "block",
    // height: "auto",
    height: "auto",
  },
  blueButton: {
    flexGrow: 1,
    backgroundColor: "#d71996",
    minHeight: 24,
    height: 24,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },
  declineButton: {
    flexGrow: 1,
    backgroundColor: "#ffffff",
    minHeight: 24,
    height: 24,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    borderColor: "#1277d9",
    borderWidth: 1,
    borderStyle: "solid"
  },
  disabled: {
    pointerEvents: "none",
    opacity: 0.5,
  },
  bottomPayButtons: {
    flexBasis: "25%",
    width: "25%",
    marginRight: 16,
    screen: ({ width }) => {
      if (width <= 1024){
        return {
          flexBasis: "24%",
          width: "24%",
          marginRight: 4,
        };
      }
    },
  },
});
